import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-admin-reports',
  templateUrl: './admin-reports.component.html',
  styleUrls: ['./admin-reports.component.scss']
})
export class AdminReportsComponent implements OnInit {
  loading: boolean = true;
  loadingData: boolean = false;
  reportList: any[] = [];
  selectedReport: string;
  tableDef: any = {};
  tableData: any[] = [];
  pageIndex: number = 0;
  pageSize: number = 50;
  pageLength: number = 0;
  count = 0;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.getTableList();
  }

  getTableList() {
    this.loading = true;

    this.http.get('/api/data/reports').subscribe((res: any) => {
      this.reportList = res.map(report => {
        const schema = JSON.parse(report.schema || '[]');
        report['schema'] = schema.filter(itm => itm.visible);
        report['pagedOn'] = true;
        report['filterOn'] = true;
        report['sortOn'] = true;
        return report;
      });
      
      this.selectedReport = this.reportList[0].id;
      this.loading = false;
      this.loadTableData();
    }, (err: any) => {
      console.log(err);
    });
  }

  loadTableData() {
    this.count++;
    const count = this.count;
    this.loadingData = true;

    this.http.get(`/api/data/reportdata?reportId=${this.selectedReport}`).subscribe((res: any) => {
      if (count === this.count) {
        this.pageIndex = 0;
        this.pageSize = 50;
        this.pageLength = res.length;
        const item = this.reportList.find(itm => itm.id === this.selectedReport);
        const { id, reportname, pagedOn, filterOn, sortOn, schema } = item;
        const tableDef = {
          id,
          reportname,
          pagedOn,
          filterOn,
          sortOn,
          fields: [...schema]
        };

        const attachmentType = schema.find(itm => itm.type === 'attachment');
        if (attachmentType && Array.isArray(res)) {
          const { name } = attachmentType;
          res.forEach(itm => {
            if (itm.hasOwnProperty(name) && itm[name]) {
              try {
                itm[name] = JSON.parse(itm[name]);
              } catch(err) {}
            }
          });
        }

        this.tableDef = tableDef;
        this.tableData = res;
        this.loadingData = false;
      }
    }, (err: any) => {
      console.log(err);
    });
  }

  gridPageChange(pagination) { }
}
